import React from 'react';
import AdvancedHeader from '../components/AdvancedHeader';
import AdvancedHero from '../components/AdvancedHero';
import StatisticsSection from '../components/StatisticsSection';
import ServicesShowcase from '../components/ServicesShowcase';
import FundingLevelsSection from '../components/FundingLevelsSection';
import ApplicationJourneySection from '../components/ApplicationJourneySection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FloatingContact from '../components/FloatingContact';

const HomePage = () => {
  return (
    <div className="relative bg-white">
      <AdvancedHeader />
      <main>
        <div id="home">
          <AdvancedHero />
        </div>
        
        <StatisticsSection />
        
        <div id="services">
          <ServicesShowcase />
        </div>
        
        <div id="funding">
          <FundingLevelsSection />
        </div>
        
        <ApplicationJourneySection />
        
        <WhyChooseUsSection />
        
        <div id="contact">
          <ContactSection />
        </div>
      </main>
      <Footer />
      <FloatingContact />
    </div>
  );
};

export default HomePage;
